import React, {Fragment} from 'react';
import styled from 'styled-components';

import Overlay from '../Overlay';
import VisibilityAnimation from '../VisibilityAnimation';

import Modal from './Modal';

function SideModal({title, header, tabs, options, footer, open, large, onClose, children}) {
  if (options && !Array.isArray(options)) {
    options = [options];
  }

  return (
    <Fragment>
      <Overlay visible={open} onClick={onClose} />
      <Container show={["slide-in-right", "fade-in"]} hide={["slide-out-right", "fade-out"]} visible={open}>
        <Modal title={title} header={header} tabs={tabs} options={options} footer={footer} large={large} onClose={onClose}>{children}</Modal>
      </Container>
    </Fragment>
  );
}

const Container = styled(VisibilityAnimation)`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 30;
`;

const SideModalContent = styled.div`
  min-height: 100%;
  padding: 1.875rem;

  @media (max-width: 37rem) {
    padding: 1.25rem;
  }
`;

SideModal.Content = SideModalContent;
export default SideModal;